import React, { lazy, Suspense } from "react";
import "./home.style.css";

const Header = lazy(() => import("../../common/Header"));
const Footer = lazy(() => import("../../common/Footer"));
const List = lazy(() => import("./Content/List"));
const Map = lazy(() => import("./Content/Map"));
const Form = lazy(() => import("./Content/Form/Form"));
const PicturesSlider = lazy(() =>
  import("./Content/PicturesSlider/PicturesSlider")
);
const HeaderPromo = lazy(() => import("./Content/Text/HeaderPromo"));
const ServiceDetails = lazy(() => import("./Content/Text/ServiceDetails"));
const WhyChooseUs = lazy(() => import("./Content/Text/WhyChooseUs"));
const Contact = lazy(() => import("./Content/Text/Contact"));

function Home() {
  return (
    <div className="home-container">
      <Header />
      <HeaderPromo />
      <Suspense fallback={<div>Loading...</div>}>
      <List />
        <ServiceDetails />
        <WhyChooseUs />
        <Contact />

        <PicturesSlider />
        <Map />
        <Form />
      </Suspense>

      <Footer />
    </div>
  );
}

export default Home;
